/* A fixed home header never changes document flow. One observer supplies its state. */
if (!customElements.get('ounce-header-state')) {
  customElements.define('ounce-header-state', class extends HTMLElement {
    connectedCallback() {
      if (this.observer || this.events) return;
      const main = document.getElementById('MainContent');
      const section = this.closest('.shopify-section');
      // If the editor moves the photograph below another section, keep normal navigation.
      if (main && section && section !== main.firstElementChild) {
        document.documentElement.dataset.ounceHeader = 'solid';
        return;
      }
      this.events = new AbortController();
      this.update = () => {
        const top = this.getBoundingClientRect().bottom > 0;
        document.documentElement.dataset.ounceHeader = top ? 'top' : 'solid';
      };
      if (!('IntersectionObserver' in window)) {
        document.documentElement.dataset.ounceHeader = 'solid';
        return;
      }
      this.update();
      this.observer = new IntersectionObserver(() => this.update(), { threshold: 0 });
      this.observer.observe(this);
      window.addEventListener('pageshow', this.update, { signal: this.events.signal });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.events?.abort();
      this.events = null;
      document.documentElement.dataset.ounceHeader = 'solid';
    }
  });
}
